$(document).ready(function () {
  $(".payout-form").on("click mousedown keydown", function () {
    $(this).submit(false);
  });
});
